// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2iQ_m","productName":"Table_productName__3sVpB"};